// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalOverlay--Iu32w {
  z-index: 2000 !important;
}

.modalWrapper--S640y {
  max-width: 650px !important;
  top: 0 !important;
  opacity: 0;
  overflow-y: auto;
}

[dir] .modalWrapper--S640y {
  transform: translateY(0) !important;
}

[dir=ltr] .modalWrapper--S640y {
  animation: show--vCCwt 0.2s linear 0s 1 normal forwards;
}

[dir=rtl] .modalWrapper--S640y {
  animation: show--vCCwt 0.2s linear 0s 1 normal forwards;
}

.modalWrapper--S640y h2 {
  color: #333 !important;
  font-size: 24px !important;
}

.modalWrapper--S640y button {
  width: auto;
  height: auto;
}

[dir] .description--JSvJJ {
  margin-bottom: 16px;
}

@keyframes show--vCCwt {
  from {
    transform: translateY(-100px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/js/components/Modals/Information/styles.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EAGjB,UAAU;EACV,gBAAgB;AAClB;;AAPA;EAGE,mCAAmC;AAIrC;;AAPA;EAIE,uDAAgD;AAGlD;;AAPA;EAIE,uDAAgD;AAGlD;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,6BAA6B;IAC7B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":[".modalOverlay {\n  z-index: 2000 !important;\n}\n\n.modalWrapper {\n  max-width: 650px !important;\n  top: 0 !important;\n  transform: translateY(0) !important;\n  animation: show 0.2s linear 0s 1 normal forwards;\n  opacity: 0;\n  overflow-y: auto;\n}\n\n.modalWrapper h2 {\n  color: #333 !important;\n  font-size: 24px !important;\n}\n\n.modalWrapper button {\n  width: auto;\n  height: auto;\n}\n\n.description {\n  margin-bottom: 16px;\n}\n\n@keyframes show {\n  from {\n    transform: translateY(-100px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `modalOverlay--Iu32w`,
	"modalWrapper": `modalWrapper--S640y`,
	"show": `show--vCCwt`,
	"description": `description--JSvJJ`
};
export default ___CSS_LOADER_EXPORT___;
